'use strict';
const toMap = (arr = [], key, value_key) => {
    return arr.reduce((pre, next) => {
        pre[next[key]] = value_key ? next[value_key] : next;
        return pre;
    }, {});
};

// 步骤动作类型
const actionType = [
    { value: 0, key: 'Move', name: '移动' },
    { value: 1, key: 'Rotate', name: '旋转' },
    { value: 2, key: 'bfdh', name: '播放动画' },
    { value: 3, key: 'HighLightOn', name: '高亮' },
    { value: 4, key: 'HighLightOff', name: '取消高亮' },
    { value: 5, key: 'PlayerAction', name: '玩家操作' },
    { value: 6, key: 'MoveCamera', name: '摄像机操作' },
    { value: 7, key: 'MetaAction', name: '元件操作' },
    { value: 8, key: 'OpenForm', name: '打开表单' },
    { value: 9, key: 'OpenUI', name: '打开UI' },
    { value: 10, key: 'Self', name: '自定义行为' },
    { value: 11, key: 'talk', name: '文本对话框' },
    { value: 12, key: 'tag', name: '标签' },
    { value: 13, key: 'PlayVideo', name: '播放视频' },
    { value: 14, key: 'PrintLog', name: '打印日志' },
    { value: 15, key: 'OpenImage', name: '打开图片' },
    { value: 16, key: 'Exam', name: '考核' },
];

exports.actionTypeMap = toMap(actionType, 'key', 'name');

exports.actionType = actionType;